import React from 'react';
const Preloader = (props) => (
  <div className='flex flex-col justify-center' style={{ padding: '3.8%' }}>
    <img alt='' className='mb-4 mx-auto w-32' src='/assets/img/loader2.gif' />
    <h2 className='texto-carga text-center'>{props.titulo}</h2>
  </div>
);
export default Preloader;
